import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon_15.png'
import _imports_1 from '@/assets/icon_52.png'


const _withScopeId = n => (_pushScopeId("data-v-48c28114"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fz-18 co-1F2D48 font-blod" }, "个人信息", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wh-12 pointer",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fz-15 co-1F2D48" }, "上传照片", -1))
const _hoisted_5 = { class: "flex-row-end" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "avatar"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-20" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "flex-row-center-start fz-12",
    style: {"line-height":"normal"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "point bg-0066FF" }),
    /*#__PURE__*/_createElementVNode("div", { class: "co-949CA9 ml-6" }, "请上传72*72px的图片")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "flex-row-center-start fz-12 mt-8",
    style: {"line-height":"normal"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "point bg-0066FF" }),
    /*#__PURE__*/_createElementVNode("div", { class: "co-949CA9 ml-6" }, "图片大小不得超过5MB")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "flex-row-center-start fz-12 mt-8",
    style: {"line-height":"normal"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "point bg-0066FF" }),
    /*#__PURE__*/_createElementVNode("div", { class: "co-949CA9 ml-6" }, "请上传公司LOGO")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "screen-label" }, "用户名称", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "screen-label" }, "手机号码", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "screen-label" }, "电子邮箱", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "screen-label" }, "角色类型", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "screen-label" }, "创建日期", -1))
const _hoisted_14 = { class: "flex-row-center-end" }

import { ref, getCurrentInstance } from 'vue';
	import config from '@/api/config';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'InfoPop',
  emits: ["change"],
  setup(__props, { expose: __expose, emit: __emit }) {

	const { proxy } = getCurrentInstance() as any;
	const emits = __emit;
	const pop = ref<any>(false);
	const form = ref<any>();
	const params = ref<any>({
		avatar: "",
		nickname: "",
		phone: "",
		mail: "",
		warehouse_id: "",
		auth_txt: "",
		time: "",
	});
	const rules = ref({
		nickname: [{
			required: true,
			message: "姓名不能为空",
			trigger: "blur",
		}],
	});
	const details = ref<any>();

	const Submit = async () => {
		if (!params.value.avatar) {
			proxy.$message.error("请上传头像");
			return false;
		}
		await form.value.validate((e : any) => {
			if (e) {
				let data : any = JSON.parse(JSON.stringify(params.value));
				proxy.$api.tokenRequest({
					url: '/admin/admin',
					isLoading: '加载中...',
					method: "PUT",
					data: {
						avatar: data.avatar,
						nickname: data.nickname,
					},
					success: () => {
						close();
						emits("change");
					},
				});
			}
		});
	};
	const beforeAvatarUpload = (rawFile : any) => {
		if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png' && rawFile.type !== 'image/png') {
			proxy.$message.error("图片格式只能为jpeg格式或者png格式");
			return false
		}
		return true
	};
	const handleAvatarSuccess = (data : any) => {
		params.value.avatar = data.data;
	};
	const open = () => {
		pop.value = true;
		let user : any = JSON.parse(localStorage.getItem("userInfo") as any);
		console.log(user)
		details.value = user;
		params.value.avatar = user.info.avatar;
		params.value.nickname = user.info.nickname;
		params.value.phone = user.info.phone;
		params.value.mail = user.info.mail;
		params.value.warehouse_id = user.info.warehouse_id;
		params.value.auth_text = user.info.auth_text;
		params.value.create_time = user.info.create_time;
	};
	const close = () => {
		pop.value = false;
	};

	__expose({
		open,
		close,
	})

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: pop.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((pop).value = $event)),
      draggable: "",
      width: "810px",
      "destroy-on-close": "",
      "align-center": true,
      "show-close": false
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", { class: "flex-row-center-sb pl-30 ptb-22 boderb1-EBEBED" }, [
          _hoisted_1,
          _createElementVNode("div", {
            class: "pr-30",
            onClick: close
          }, _hoisted_3)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_button, {
            class: "cancel-btn",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "save-btn",
            type: "primary",
            onClick: Submit
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "form",
          ref: form,
          size: "large",
          inline: true,
          "label-position": "top",
          rules: rules.value,
          model: params.value,
          class: "plr-30 pt-30"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { prop: "avatar" }, {
                      label: _withCtx(() => [
                        _hoisted_4
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_el_upload, {
                            class: "avatar",
                            action: `${_unref(config).request_host}/admin/upload`,
                            "show-file-list": false,
                            "on-success": handleAvatarSuccess,
                            "before-upload": beforeAvatarUpload
                          }, {
                            default: _withCtx(() => [
                              (params.value.avatar)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: params.value.avatar,
                                    class: "avatar"
                                  }, null, 8, _hoisted_6))
                                : (_openBlock(), _createElementBlock("img", _hoisted_7))
                            ]),
                            _: 1
                          }, 8, ["action"]),
                          _hoisted_8
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { prop: "nickname" }, {
                      label: _withCtx(() => [
                        _hoisted_9
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "w-100",
                          modelValue: params.value.nickname,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((params.value.nickname) = $event)),
                          placeholder: "请填写用户名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, null, {
                      label: _withCtx(() => [
                        _hoisted_10
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "w-100",
                          disabled: "",
                          modelValue: params.value.phone,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((params.value.phone) = $event)),
                          placeholder: "暂无"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, null, {
                      label: _withCtx(() => [
                        _hoisted_11
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "w-100",
                          disabled: "",
                          modelValue: params.value.mail,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((params.value.mail) = $event)),
                          placeholder: "暂无"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, null, {
                      label: _withCtx(() => [
                        _hoisted_12
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "w-100",
                          disabled: "",
                          modelValue: params.value.auth_text,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((params.value.auth_text) = $event)),
                          placeholder: "暂无"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, null, {
                      label: _withCtx(() => [
                        _hoisted_13
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "w-100",
                          disabled: "",
                          modelValue: params.value.create_time,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((params.value.create_time) = $event)),
                          placeholder: "请输入创建日期"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})